import { createContext, useCallback, useEffect, useState } from "react";
import {
    getDistrictData,
    getStateData,
} from "../services/adminApiService/dsoAPIs/dsoApis";
import { DeleteAccountUser, getAccountRoleList, getAccountUserAssignRoleList, getAccountUserList, getAccountUserProfile, getAccountUserRolePermission, getAccountUserStatisticsList, getAssignRoleList, getBlocks, getNyayPanchayats } from "../services/adminApiService/accountManagementApi/AccountManagementApiService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
export const AccountManagementContext = createContext();

export const AccountManagementProvider = ({ children }) => {
    const [showCreateDSO, setShowCreateDSO] = useState(false);
     const [accountProfileData, setAccountProfileData] = useState();
    const setShowCreateModal = () => setShowCreateDSO(true);
    const [accountUserAssingData, setAccountUserAssingData] = useState([]);
    const [DeleteaccountUserData, setDeleteaccountUserData] = useState([]);
    const navigate = useNavigate();

    const handleClose = () => {
        setEditData(null);      // clear edit mode
        setFormData({});        // clear form fields
        setErrors({});          // clear validation errors
        // setShowPassword(false); // optional: reset password visibility
        setShowCreateDSO(false);
    };
    const [loading, setIsLoading] = useState(false);
    const [statesList, setStatesList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [blockList, setBlockList] = useState([]);
    const [nyayPanchayatList, setNyayPanchayatList] = useState([]);
    const [userAccountList, setUserAccountList] = useState([]);
    const [RoleAccountList, setRoleAccountList] = useState([]);
    const [RolePermissionList, setRolePermissionList] = useState([]);
    const [assignUserList, setAssignUserList] = useState([]);
   const [statisticsdataList, setstatisticsdataList] = useState([]);

    const [errors, setErrors] = useState({});
    const [editData, setEditData] = useState(null);


    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        password: "",
        state: "",
        district: "",
        adminCateogry: "",
        adminLevel: "",
        block: "",
        nyayPanchayat: "",
    });


    // Fetch states
    const fetchStates = useCallback(async () => {
        try {
            const res = await getStateData(101);
            setStatesList(res.data || []);
        } catch (error) {
            console.error("Error fetching states:", error);
        }
    }, []);

    // Fetch districts when state changes
    const fetchDistricts = useCallback(async (stateId) => {
        try {
            if (!stateId) return;
            const res = await getDistrictData(stateId);
            setDistrictList(res.data || []);
        } catch (error) {
            console.error("Error fetching districts:", error);
        }
    }, []);

    const fetchBlocks = useCallback(async (districtId) => {
        try {
            if (!districtId) { setBlockList([]); return; }
            const res = await getBlocks(districtId);
            setBlockList(res?.data?.data || []);
        } catch (error) {
            console.error("Error fetching blocks:", error);
        }
    }, []);

    const fetchNyayPanchayats = useCallback(async (blockId) => {
        try {
            if (!blockId) { setNyayPanchayatList([]); return; }
            const res = await getNyayPanchayats(blockId);
            setNyayPanchayatList(res?.data?.data || []);
        } catch (error) {
            console.error("Error fetching nyay panchayats:", error);
        }
    }, []);

    const fetchUserAccountManagementList = useCallback(async (sort_by = "",order_by = "desc",searchValue = "", perPage = 10, currentPage = 1) => {

        try {
            setIsLoading(true);
            const res = await getAccountUserList(sort_by,order_by,searchValue,perPage, currentPage);

            setUserAccountList(res?.data || []);
        } catch (error) {
            console.error("Error fetching DSO List:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);
 const getAccountUserCount = async () => {
        setIsLoading(true);
        try {
            const response = await getAccountUserStatisticsList();
            setstatisticsdataList(response.data);
        } catch (error) {
            console.error('Login error:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchAccountuserAssignRole = useCallback(async () => {

        try {
            const res = await getAccountUserAssignRoleList();
            setAccountUserAssingData(res?.data?.data || []);

        } catch (error) {
            console.error("Error fetching admin category type:", error);
        }
    }, []);

    // ROLE AMD PERMIISSION API
    const fetchAccountuserRolePermission = useCallback(async (id) => {
        try {
            const res = await getAccountUserRolePermission(id);
            setRolePermissionList(res?.data || []);

        } catch (error) {
            console.error("Error fetching admin category type:", error);
        }
    }, []);

   


  

    const fetchRoleAccountManagementList = useCallback(async (sort_by = "",order_by = "desc",searchValue = "", perPage = 10, currentPage = 1,) => {

        try {
            setIsLoading(true);
            const res = await getAccountRoleList(sort_by,order_by,searchValue,perPage, currentPage);
            setRoleAccountList(res?.data || []);
        } catch (error) {
            console.error("Error fetching DSO List:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    const fetchAssignRoleList = useCallback(async (id) => {

        try {
            setIsLoading(true);
            const res = await getAssignRoleList(id);
            setAssignUserList(res?.data || []);
        } catch (error) {
            console.error("Error fetching DSO List:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

      const fetchVerificationList = useCallback(async (id) => {

        try {
            setIsLoading(true);
            const res = await getAccountUserProfile(id);
             setAccountProfileData(res?.data?.data);
        } catch (error) {
            console.error("Error fetching DSO List:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);


    // useEffect(() => {
    //     fetchUserAccountManagementList();
    // }, [fetchUserAccountManagementList]);






    // useEffect(() => {
    //     fetchRoleAccountManagementList();
    // }, [fetchRoleAccountManagementList]);

   

    useEffect(() => {
        if (editData) {
            setFormData({
                name: editData.name || "",
                phone: editData.phone || "",
                email: editData.email || "",
                password: editData.org_pwd || editData.decrypted_password,
                state: editData.state_id || "",
                district: editData.district_id || "",
                adminCateogry: editData.category_id || "",
            });
        } else {
            setFormData({});
        }
    }, [editData]);

    return (
        <AccountManagementContext.Provider
            value={{
                loading,
                setIsLoading,
                statesList,
                districtList,
                errors,
                setErrors,
                setFormData,
                formData,
                userAccountList,
                fetchUserAccountManagementList,
                showCreateDSO,
                setShowCreateModal,
                handleClose,
                editData,
                setEditData,
                fetchAccountuserAssignRole,
                accountUserAssingData,
                DeleteaccountUserData,
                // fetchDeleteAccountuser,
                fetchDistricts,
                blockList,
                fetchBlocks,
                nyayPanchayatList,
                fetchNyayPanchayats,
                fetchRoleAccountManagementList,
                fetchAccountuserRolePermission,
                RoleAccountList,
                RolePermissionList,
                fetchAssignRoleList,
                assignUserList,
                fetchStates,
                fetchVerificationList,
                accountProfileData,
                getAccountUserCount,
                statisticsdataList,


            }}
        >
            {children}
        </AccountManagementContext.Provider>
    );
};
